import { validatePassword } from "../../uikit.helpers/validators.es.js";
const passwordValidator = (value) => {
  return validatePassword(value);
};
export {
  passwordValidator as default
};
//# sourceMappingURL=password.es.js.map
